<template>
  <div>
    <nav class="navbar navbar-dark bg-dark">
      <a class="navbar-brand" href="#">
        <i class="fas fa-map-marked-alt"></i> Cesium Demo
      </a>
      <div>
        <b-button v-b-toggle.sidebar-right><i class="fas fa-tools"></i> Tools</b-button>
        <b-sidebar id="sidebar-right" title="Tools" bg-variant="dark" text-variant="light" right shadow>
          <div class="px-3 py-2">
            <!-- <button type="button" name="clipBtn" v-on:click="loadClipPlane" class="btn btn-light">Clipping Tool</button>
            <button type="button" name="resetBtn" v-on:click="reset" class="btn btn-light">Reset</button> -->
            <b-button variant="secondary" block v-on:click="loadClipPlane(1)"><i class="fas fa-crop-alt"></i> Horizontal Slicer</b-button>
            <b-button variant="secondary" block v-on:click="loadClipPlane(0)"><i class="fas fa-crop-alt"></i> Vertical Slicer</b-button>
            <b-button variant="secondary" block v-on:click="measuringTool"><i class="fas fa-ruler-horizontal"></i> Measurement</b-button>
            <b-button variant="secondary" block v-on:click="measuringAreaTool"><i class="fas fa-ruler-combined"></i> Measurement Area</b-button>
            <!-- <div id="measureContainer"></div> -->
            <!-- <b-button variant="secondary" block v-on:click="zoomIn"><i class="fas fa-search-plus"></i> Zoom in</b-button>
            <b-button variant="secondary" block v-on:click="zoomOut"><i class="fas fa-search-minus"></i> Zoom out</b-button> -->
            <b-button variant="secondary" block v-on:click="reset"><i class="fas fa-undo-alt"></i> Reset</b-button>
          </div>
        </b-sidebar>
      </div>
    </nav>
    <div class="custom-widget">
      <div class="pb-3">
        <b-button size="sm" variant="dark" v-on:click="backToHome"><i class="fas fa-home"></i></b-button>
      </div>
      <b-button-group vertical>
        <b-button size="sm" variant="dark" v-on:click="zoomIn"><i class="fas fa-search-plus"></i></b-button>
        <!-- <b-button size="sm" variant="dark" v-on:click="reset"><i class="fas fa-undo-alt"></i></b-button> -->
        <b-button size="sm" variant="dark" v-on:click="zoomOut"><i class="fas fa-search-minus"></i></b-button>
      </b-button-group>
    </div>
    <div class="custom-popup ">
        <b-toast title="Feature Properties" variant="dark" static no-auto-hide v-model="featureItemsVisible" class="b-toaster b-toaster-top-center custom-position">
          <table class="table table-striped table-dark table-sm">
            <tbody>
              <tr>
                <th>ID</th>
                <td>{{featureItems.id}}</td>
              </tr>
              <tr>
                <th>Height</th>
                <td>{{featureItems.height}}</td>
              </tr>
              <tr>
                <th>Longitude</th>
                <td>{{featureItems.longitude}}</td>
              </tr>
              <tr>
                <th>Latitude</th>
                <td>{{featureItems.latitude}}</td>
              </tr>
            </tbody>
          </table>
        </b-toast>
    </div>
    <div class="" id="cesiumContainer">

    </div>

  </div>
</template>

<script>
/* eslint-disable */
window.CESIUM_BASE_URL = 'CesiumAssets';
// window.CESIUM_BASE_URL = 'node_modules/cesium/Source';
// import * as Cesium from 'cesium/Build/Cesium/Cesium.js';
// import 'cesium/Build/Cesium/Widgets/widgets.css';
import * as Cesium from 'cesium';
import 'cesium/Source/Widgets/widgets.css'


export default {
  name: "Portal",
  data() {
    return {
      accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI2N2YzYWYxMS05YzczLTQ4NTYtOGM0MS03MjU2Y2Y0MDEzNzMiLCJpZCI6MTE0MTUsInNjb3BlcyI6WyJhc3IiLCJnYyJdLCJpYXQiOjE1NTg5MzYzMzN9.Qq33spG8In4jCS70jCuQdmR2oHO75QmyrBXND4ou37Y',
      // assetId: 87861,
      assetId: 90837,
      viewer: {},
      tileset: {},
      clippingPlanes: {},
      planeEntities: [],
      targetY: 0.0,
      cesiumCartesian: null,
      tempPoints: [],
      measureHandler: null,
      tempEntities: [],
      earthRadiusMeters: 6371000.0,
      radiansPerDegree: Math.PI / 180.0,
      degreesPerRadian: 180.0 / Math.PI,
      miamiTileSet: null,
      featureItems: {
        id: "",
        height: "",
        longitude: "",
        latitude: ""
      },
      featureItemsVisible: false
    }
  },
  methods: {
    zoomIn: function() {
      const current = this
      current.viewer.camera.zoomIn(100)
    },
    zoomOut: function() {
      const current = this
      current.viewer.camera.zoomOut(100)
    },
    backToHome: function() {
      const current = this
      current.reset()
      current.viewer.zoomTo(current.tileset)
    },
    measuringAreaTool: function() {
      const current = this
      current.reset()
      var scene = current.viewer.scene;
      current.tempPoints = [];
      current.measureHandler = new Cesium.ScreenSpaceEventHandler(scene.canvas);
      current.measureHandler.setInputAction(function (click) {
          var cartesian = current.viewer.camera.pickEllipsoid(click.position,scene.globe.ellipsoid);
          if (cartesian) {
              var cartographic = Cesium.Cartographic.fromCartesian(cartesian);
              var longitudeString = Cesium.Math.toDegrees(cartographic.longitude);
              var latitudeString = Cesium.Math.toDegrees(cartographic.latitude);
              current.tempPoints.push({ lon: longitudeString, lat: latitudeString });
              var tempLength = current.tempPoints.length;
              current.drawPoint(current.tempPoints[current.tempPoints.length-1]);
              if (tempLength > 1) {
                  current.drawLine(current.tempPoints[current.tempPoints.length - 2], current.tempPoints[current.tempPoints.length - 1], true);
              }
          }
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

      current.measureHandler.setInputAction(function (click) {
          var cartesian = current.viewer.camera.pickEllipsoid(click.position, scene.globe.ellipsoid);
          if (cartesian) {
              var tempLength = current.tempPoints.length;
              if (tempLength < 3) {
                  alert(' Please choose3 Close operation command for more than points');
              } else {
                  current.drawLine(current.tempPoints[0], current.tempPoints[current.tempPoints.length - 1], true);
                  current.drawPoly(current.tempPoints);
                  // highLightAssetsInArea(current.tempPoints);


          var         ent =
          current.viewer.entities.add({
              position: Cesium.Cartesian3.fromDegrees(((current.tempPoints[0].lon
                      +(current.tempPoints[current.tempPoints.length-1].lon+
                      current.tempPoints[current.tempPoints.length-2].lon)/2)/2 ),
                                          ((current.tempPoints[0].lat
                      +(current.tempPoints[current.tempPoints.length-1].lat+current.tempPoints[current.tempPoints.length -2].lat)/2
                      )/2)),
              label: {
                  text: current.sphericalPolygonAreaMeters(current.tempPoints).toFixed(1) + '㎡',
                  font: '22px Helvetica',
                  fillColor: Cesium.Color.BLACK
              }
          });
      current.tempEntities.push(ent);
                  current.tempPoints = [];
                  current.clearEffects();
              }

          }
      }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
    },
    measuringTool: function() {
      const current = this
      current.reset()
      var scene = current.viewer.scene;
      current.tempPoints = [];
      current.measureHandler = new Cesium.ScreenSpaceEventHandler(scene.canvas);
      current.measureHandler.setInputAction(function (click) {
          var cartesian = current.viewer.camera.pickEllipsoid(click.position, scene.globe.ellipsoid);
          if (cartesian) {
              var cartographic = Cesium.Cartographic.fromCartesian(cartesian);
              var longitudeString = Cesium.Math.toDegrees(cartographic.longitude);
              var latitudeString = Cesium.Math.toDegrees(cartographic.latitude);
              current.tempPoints.push({ lon: longitudeString, lat: latitudeString });
              var tempLength = current.tempPoints.length;
              current.drawPoint(current.tempPoints[current.tempPoints.length - 1]);
              if (tempLength > 1) {
                  current.drawLine(current.tempPoints[current.tempPoints.length - 2],current.tempPoints[current.tempPoints.length - 1], true);
              }
          }
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
      current.measureHandler.setInputAction(function (click) {
          current.tempPoints = [];
          current.clearEffects();
      }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);

    },
    drawPoint: function(point) {
      const current = this
      var entity = current.viewer.entities.add({
          position: Cesium.Cartesian3.fromDegrees(point.lon, point.lat),
          label: {
                      text: '',
                      font: '22px Helvetica'
                  },
          point: {
              pixelSize: 10,
              color: Cesium.Color.CHARTREUSE
          }
      });
      current.tempEntities.push(entity);
    },
    drawLine: function(point1, point2, showDistance) {
      const current = this
      var entity = current.viewer.entities.add({
          polyline: {
              positions: [Cesium.Cartesian3.fromDegrees(point1.lon, point1.lat), Cesium.Cartesian3.fromDegrees(point2.lon, point2.lat)],
              width: 10.0,
              material: new Cesium.PolylineGlowMaterialProperty({
                  color: Cesium.Color.CHARTREUSE.withAlpha(.5)
              })
          }
      });
      current.tempEntities.push(entity);
      if (showDistance) {
          var w = Math.abs(point1.lon - point2.lon);
          var h = Math.abs(point1.lat - point2.lat);
          var offsetV = w >= h ? 0.0005 : 0;
          var offsetH = w < h ? 0.001 : 0;
          var distance = current.getFlatternDistance(point1.lat, point1.lon, point2.lat, point2.lon);
          entity =
              current.viewer.entities.add({
                  position: Cesium.Cartesian3.fromDegrees(((point1.lon + point2.lon) / 2) + offsetH,
                  ((point1.lat + point2.lat) / 2) + offsetV),
                  label: {
                      text: distance.toFixed(1) + 'm',
                      font: '22px Helvetica',
                      fillColor: Cesium.Color.WHITE
                  }
              });
          current.tempEntities.push(entity);
      }
    },
    drawPoly: function(points) {
      const current = this
        var pArray = [];
        for (var i = 0; i < points.length; i ++) {
            pArray.push(points[i].lon);
            pArray.push(points[i].lat);
        }
        var entity =
        current.viewer.entities.add({
            polygon: {
                hierarchy: new Cesium.PolygonHierarchy(Cesium.Cartesian3.fromDegreesArray(pArray)),
                material: Cesium.Color.CHARTREUSE.withAlpha(.5)
            }
        });
        current.tempEntities.push(entity);
    },
    getFlatternDistance: function(lat1, lng1, lat2, lng2) {
        var EARTH_RADIUS = 6378137.0;    // CompanyM
        var PI = Math.PI;

        function getRad(d) {
            return d * PI / 180.0;
        }
        var f = getRad((lat1 + lat2) / 2);
        var g = getRad((lat1 - lat2) / 2);
        var l = getRad((lng1 - lng2) / 2);

        var sg = Math.sin(g);
        var sl = Math.sin(l);
        var sf = Math.sin(f);

        var s, c, w, r, d, h1, h2;
        var a = EARTH_RADIUS;
        var fl = 1 / 298.257;

        sg = sg * sg;
        sl = sl * sl;
        sf = sf * sf;

        s = sg * (1 - sl) + (1 - sf) * sl;
        c = (1 - sg) * (1 - sl) + sf * sl;

        w = Math.atan(Math.sqrt(s / c));
        r = Math.sqrt(s * c) / w;
        d = 2 * w * a;
        h1 = (3 * r - 1) / 2 / c;
        h2 = (3 * r + 1) / 2 / s;

        return d * (1 + fl * (h1 * sf * (1 - sg) - h2 * (1 - sf) * sg));
    },
    sphericalPolygonAreaMeters: function(points) {
      const current = this
      var totalAngle = 0;
      for (var i = 0; i < points.length; i++) {
          var j = (i + 1) % points.length;
          var k = (i + 2) % points.length;
          totalAngle += current.angle(points[i], points[j], points[k]);
      }
      var planarTotalAngle = (points.length - 2) * 180.0;
      var sphericalExcess = totalAngle - planarTotalAngle;
      if (sphericalExcess > 420.0) {
          totalAngle = points.length * 360.0 - totalAngle;
          sphericalExcess = totalAngle - planarTotalAngle;
      } else if (sphericalExcess > 300.0 && sphericalExcess < 420.0) {
          sphericalExcess = Math.abs(360.0 - sphericalExcess);
      }
      return sphericalExcess * current.radiansPerDegree * current.earthRadiusMeters * current.earthRadiusMeters;
    },
    angle: function(p1, p2, p3) {
      const current = this
      var bearing21 = current.bearing(p2, p1);
      var bearing23 = current.bearing(p2, p3);
      var angle = bearing21 - bearing23;
      if (angle < 0) {
          angle += 360;
      }
      return angle;
    },
    bearing: function(from, to) {
      const current = this
      var lat1 = from.lat * current.radiansPerDegree;
      var lon1 = from.lon * current.radiansPerDegree;
      var lat2 = to.lat * current.radiansPerDegree;
      var lon2 = to.lon * current.radiansPerDegree;
      var angle = -Math.atan2(Math.sin(lon1 - lon2) * Math.cos(lat2), Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon1 - lon2));
      if (angle < 0) {
          angle += Math.PI * 2.0;
      }
      angle = angle * current.degreesPerRadian;
      return angle;
    },
    clearEffects: function() {
      const current = this
      if (current.measureHandler != null) {
          current.measureHandler.destroy();
      }
    },
    loadScene: function() {
      // console.log(Cesium);
      const current = this
      Cesium.Ion.defaultAccessToken = current.accessToken
      // var viewer = new Cesium.Viewer('cesiumContainer')
      current.viewer = new Cesium.Viewer('cesiumContainer', {
          scene3DOnly: true,
          selectionIndicator: false,
          baseLayerPicker: true,
          homeButton: false,
          animation: false,
          timeline: false
      });

      var miamiCyberCity = Cesium.IonResource.fromAssetId(current.assetId);
      // var tileset;

      miamiCyberCity.then(resultURL=>{
        console.log(resultURL);
        current.tileset = new Cesium.Cesium3DTileset({
            url: resultURL
        });
        current.tileset = current.viewer.scene.primitives.add(current.tileset)
        console.log(current.tileset);

         current.viewer.zoomTo(current.tileset)
             .otherwise(function (error) {
                 console.log(error);
             });
      })
    },
    loadClipPlane: function(isHorizontal){
      const current = this
      current.reset()
      if(isHorizontal){
        current.cesiumCartesian = new Cesium.Cartesian3(0.0, 0.0, -1.0)
      }
      else {
        current.cesiumCartesian = new Cesium.Cartesian3(-1.0, 0.0, 0.0)
      }
      var scene = current.viewer.scene;
      // var targetY = 0.0;
      // var planeEntities = [];
      var selectedPlane;
      // var clippingPlanes;

      // var viewModel = {
      //     debugBoundingVolumesEnabled : false,
      //     edgeStylingEnabled : true,
      //     exampleTypes : clipObjects,
      //     currentExampleType : clipObjects[0]
      // }

      // Select plane when mouse down
      var downHandler = new Cesium.ScreenSpaceEventHandler(current.viewer.scene.canvas);
      downHandler.setInputAction(function(movement) {
          var pickedObject = scene.pick(movement.position);
          if (Cesium.defined(pickedObject) &&
                  Cesium.defined(pickedObject.id) &&
                  Cesium.defined(pickedObject.id.plane)) {
              selectedPlane = pickedObject.id.plane;
              selectedPlane.material = Cesium.Color.WHITE.withAlpha(0.05);
              selectedPlane.outlineColor = Cesium.Color.WHITE;
              scene.screenSpaceCameraController.enableInputs = false;
          }
      }, Cesium.ScreenSpaceEventType.LEFT_DOWN);

      // Release plane on mouse up
      var upHandler = new Cesium.ScreenSpaceEventHandler(current.viewer.scene.canvas);
      upHandler.setInputAction(function() {
          if (Cesium.defined(selectedPlane)) {
              selectedPlane.material = Cesium.Color.WHITE.withAlpha(0.1);
              selectedPlane.outlineColor = Cesium.Color.WHITE;
              selectedPlane = undefined;
          }

          scene.screenSpaceCameraController.enableInputs = true;
      }, Cesium.ScreenSpaceEventType.LEFT_UP);

      // Update plane on mouse move
      var moveHandler = new Cesium.ScreenSpaceEventHandler(current.viewer.scene.canvas);
      moveHandler.setInputAction(function(movement) {
          if (Cesium.defined(selectedPlane)) {
              var deltaY = movement.startPosition.y - movement.endPosition.y;
              current.targetY += deltaY;
          }
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

      var bimUrl = Cesium.IonResource.fromAssetId(current.assetId);

      current.loadTileset(bimUrl);


    },
    createPlaneUpdateFunction: function(plane) {
      const current = this
        return function () {
            plane.distance = current.targetY;
            return plane;
        };
    },
    loadTileset: function(modelUrl) {
        const current = this
        current.clippingPlanes = new Cesium.ClippingPlaneCollection({
            planes : [
                // new Cesium.ClippingPlane(new Cesium.Cartesian3(0.0, 0.0, -1.0), 0.0)
                new Cesium.ClippingPlane(current.cesiumCartesian, 0.0)
            ],
            edgeWidth : 1.0
        });

        // current.tileset = {}
        // current.tileset.show = false
        // current.tileset = current.viewer.scene.primitives.add(new Cesium.Cesium3DTileset({
        //     url : modelUrl,
        //     clippingPlanes : current.clippingPlanes
        // }));
        current.tileset.clippingPlanes = current.clippingPlanes
        console.log(current.tileset);


        current.tileset.debugShowBoundingVolume = false;
        // return current.tileset.readyPromise.then(function() {
        return current.tileset.readyPromise.then(function() {
            var boundingSphere = current.tileset.boundingSphere;
            var radius = boundingSphere.radius;

            // current.viewer.zoomTo(current.tileset, new Cesium.HeadingPitchRange(0.5, -0.2, radius * 4.0));
            current.viewer.zoomTo(current.tileset, new Cesium.HeadingPitchRange(4.5, -0.2, radius * 2.5));

            if (!Cesium.Matrix4.equals(current.tileset.root.transform, Cesium.Matrix4.IDENTITY)) {
                // The clipping plane is initially positioned at the tileset's root transform.
                // Apply an additional matrix to center the clipping plane on the bounding sphere center.
                var transformCenter = Cesium.Matrix4.getTranslation(current.tileset.root.transform, new Cesium.Cartesian3());
                var transformCartographic = Cesium.Cartographic.fromCartesian(transformCenter);
                var boundingSphereCartographic = Cesium.Cartographic.fromCartesian(current.tileset.boundingSphere.center);
                var height = boundingSphereCartographic.height - transformCartographic.height;
                current.clippingPlanes.modelMatrix = Cesium.Matrix4.fromTranslation(new Cesium.Cartesian3(0.0, 0.0, height));
            }

            for (var i = 0; i < current.clippingPlanes.length; ++i) {
                var plane = current.clippingPlanes.get(i);
                var planeEntity = current.viewer.entities.add({
                    position : boundingSphere.center,
                    plane : {
                        dimensions : new Cesium.Cartesian2(radius * 2.5, radius * 2.5),
                        material : Cesium.Color.WHITE.withAlpha(0.1),
                        plane : new Cesium.CallbackProperty(current.createPlaneUpdateFunction(plane), false),
                        outline : true,
                        outlineColor : Cesium.Color.WHITE
                    }
                });

                current.planeEntities.push(planeEntity);
            }
            return current.tileset;
        }).otherwise(function(error) {
            console.log(error);
        });
    },
    reset: function(){
      const current = this
      current.viewer.entities.removeAll();
      current.viewer.scene.primitives.remove(current.tileset);
      current.clippingPlanes = {}
      current.planeEntities = []
      current.tileset = current.viewer.scene.primitives.add(new Cesium.Cesium3DTileset({
          url : Cesium.IonResource.fromAssetId(current.assetId)
      }));
    },
  },
  beforemount(){
  },
  mounted() {
    const current = this
    this.loadScene()

    // feature picking
    var nameOverlay = document.createElement('div');
    current.viewer.container.appendChild(nameOverlay);
    nameOverlay.className = 'alert alert-secondary';
    nameOverlay.style.display = 'none';
    nameOverlay.style.position = 'absolute';
    nameOverlay.style.bottom = '0';
    nameOverlay.style.left = '0';
    nameOverlay.style['pointer-events'] = 'none';
    // nameOverlay.style.padding = '4px';
    // nameOverlay.style.backgroundColor = 'white';

    var selected = {
        feature: undefined,
        originalColor: new Cesium.Color()
    }
    var highlighted = {
        feature : undefined,
        originalColor : new Cesium.Color()
    }
    var selectedEntity = new Cesium.Entity();
    var clickHandler = current.viewer.screenSpaceEventHandler.getInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
    // when hover
    current.viewer.screenSpaceEventHandler.setInputAction(function onLeftClick(movement){

      // if (Cesium.defined(highlighted.feature)) {
      //     highlighted.feature.color = highlighted.originalColor
      //     highlighted.feature = undefined
      // }

      var feature = current.viewer.scene.pick(movement.endPosition)
      if (Cesium.defined(feature)) {
        current.viewer._container.style.cursor = "pointer"
        // nameOverlay.style.display = 'block';
        // nameOverlay.style.bottom = current.viewer.canvas.clientHeight - movement.endPosition.y + 'px';
        // nameOverlay.style.left = movement.endPosition.x + 'px';
        // nameOverlay.textContent = feature._batchId
      }
      else {
        current.viewer._container.style.cursor = "default"
        // nameOverlay.style.display = 'none'
        return
      }

      // if (feature !== selected.feature) {
      //     highlighted.feature = feature;
      //     Cesium.Color.clone(feature.color, highlighted.originalColor);
      //     feature.color = Cesium.Color.YELLOW;
      // }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)

    // when clicking a feature
    current.viewer.screenSpaceEventHandler.setInputAction(function onLeftClick(movement){

      if (Cesium.defined(selected.feature)) {
          selected.feature.color = selected.originalColor
          selected.feature = undefined
      }

      var feature = current.viewer.scene.pick(movement.position)
      if (selected.feature === feature) {
          return;
      }
      selected.feature = feature
      if (Cesium.defined(feature)) {
        console.log("feature clicked");
        console.log(feature);
        if (feature instanceof Cesium.Cesium3DTileFeature) {
            var propertyNames = feature.getPropertyNames();
            var length = propertyNames.length;
            for (var i = 0; i < length; ++i) {
                var propertyName = propertyNames[i];
                console.log(propertyName + ': ' + feature.getProperty(propertyName));
            }
        }
        if (feature === highlighted.feature) {
            Cesium.Color.clone(highlighted.originalColor, selected.originalColor);
            highlighted.feature = undefined;
        } else {
            Cesium.Color.clone(feature.color, selected.originalColor);
        }
        feature.color = Cesium.Color.LIME
        current.featureItems.id = feature._batchId
        current.featureItems.longitude = feature.getProperty('Longitude')
        current.featureItems.latitude = feature.getProperty('Latitude')
        current.featureItems.height = feature.getProperty('Height')
        current.featureItemsVisible = true
        // selectedEntity.name = "ID: "+feature._batchId;
        // selectedEntity.description = 'Loading <div class="cesium-infoBox-loading"></div>';
        // current.viewer.selectedEntity = selectedEntity;
        // selectedEntity.description = '<table class="table table-dark"><tbody>' +
        //                              '<tr><th>Longitude</th><td>' + feature.getProperty('Longitude') + '</td></tr>' +
        //                              '<tr><th>Latitude</th><td>' + feature.getProperty('Latitude') + '</td></tr>' +
        //                              '<tr><th>Height</th><td>' + feature.getProperty('Height') + '</td></tr>' +
        //                              '</tbody></table>';
      }
      else{
        clickHandler(movement)
        current.featureItemsVisible = false
        console.log("Not a feature")
        return
      }




    }, Cesium.ScreenSpaceEventType.LEFT_CLICK)

  }
}
</script>

<style>
  .custom-widget {
    top: 65px;
    left: 5px;
    position: absolute;
    z-index: 1;
  }
  .custom-popup {
    position: absolute;
    z-index: 1;
  }
  .custom-position{
    top: 100px !important;
    left: 100px !important;
  }
  .cesium-infoBox-description {
    color: white !important;
  }

  .b-toast-dark .toast {
    background-color: #343a40 !important;
  }
  .b-toast-dark .toast .toast-header {
      color: #ffffff !important;
      background-color: #343a40 !important;
      /* border-bottom-color: rgba(198, 200, 202, 0.85); */
  }
  .close {
    color: #ffffff !important;
  }
</style>
